module.exports = __webpack_public_path__ + "static/img/zbbl1-4.8d437d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/zbbl1-4.png
// module id = 814
// module chunks = 0